module.exports = __webpack_public_path__ + "images/Bitcoin-8bc3e1.png";